import IconRenderer from "@/components/feature/IconRenderer";

interface DevelopmentBarProps {
  label: string;
  percentage: number;
  score: number;
  total: number;
  color: string;
  status: string;
  statusColor: string;
  iconUrl?: string;
  fallbackIcon?: string;
}

export default function DevelopmentBar({
  label,
  percentage,
  score,
  total,
  color,
  status,
  statusColor,
  iconUrl,
  fallbackIcon,
}: DevelopmentBarProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 md:gap-3">
          <div
            className="w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${color}15` }}
          >
            <IconRenderer iconUrl={iconUrl} fallbackIcon={fallbackIcon} color={color} size={16} />
          </div>
          <div>
            <span className="text-sm md:text-base font-semibold text-navy-400">{label}</span>
            <span className="text-xs text-gray-400 ml-2">({score}/{total})</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-lg md:text-xl font-bold" style={{ color }}>
            {percentage}%
          </span>
          <span
            className="text-xs font-medium px-2 py-1 rounded-full"
            style={{ backgroundColor: `${statusColor}15`, color: statusColor }}
          >
            {status}
          </span>
        </div>
      </div>
      <div className="w-full h-3 md:h-4 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-1000 ease-out"
          style={{
            width: `${percentage}%`,
            backgroundColor: color,
          }}
        />
      </div>
    </div>
  );
}